import { propsFactory } from '@components/utils';

import type { InjectionKey, PropType } from 'vue';

export const CssGridSymbol: InjectionKey<boolean> = Symbol.for('cssGrid');
export interface IUseGrid {
  prefix: string;
}
export const makeGridProps = propsFactory(
  {
    /**
     * Конденсированная сетка. Уменьшенный отступ до 1px по обеим сторонам
     */
    condensed: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    /**
     * Узкая сетка
     */
    narrow: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  'grid'
);

export const useGrid = (): IUseGrid => {
  return {
    prefix: 'cds'
  };
};
